
import { defineComponent, onMounted, nextTick, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n/index";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import VOtpInput from "vue3-otp-input";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "password-reset",
  components: {
    VOtpInput,
  },
  setup() {
    const otp = ref("");
    const otpInput = ref(null);
    const otpError = ref(false);
    const store = useStore();
    const resetFormRef = ref<HTMLFormElement | null>(null);
    const newPasswordRef = ref<HTMLFormElement | null>(null);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const currentStepIndex = ref(1);
    const { t, te } = useI18n();
    const token = ref("");
    const newPasswordForm = ref({
      password: "",
      confirmPassword: "",
    });

    const router = useRouter();

    const handleOnComplete = (value: string) => {
      otp.value = value;
    };
    const handleOnChange = (value: string) => {
      otp.value = value;
    };

    const sendCodeAgain = () => {
      // conosle.log()
    };

    const resetForm = ref({
      email: "",
    });
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };
    onMounted(() => {
      nextTick(() => {
        reinitializeComponents();
      });
    });

    //Form submit function
    const onSubmitForgotPassword = () => {
      if (!resetFormRef.value) return;

      resetFormRef.value.validate((valid) => {
        if (valid) {
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          // Activate loading indicator
          submitButton.value?.setAttribute("data-kt-indicator", "on");

          // Send login request
          store
            .dispatch(Actions.FORGOT_PASSWORD, resetForm.value)
            .then((response) => {
              Swal.fire({
                text: response.message,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: translate("ok"),
                customClass: {
                  confirmButton: "btn fw-bold btn-primary px-14",
                },
              }).then(() => {
                currentStepIndex.value = 2;
              });
            })
            .catch(() => {
              Swal.fire({
                text: store.getters.getErrors,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: translate("tryAgain"),
                customClass: {
                  confirmButton: "btn fw-bold btn-light-danger",
                },
              });
            });

          submitButton.value?.removeAttribute("data-kt-indicator");
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        }
      });
    };

    const verifiyOtp = () => {
      if (!otpInput.value) return;

      // eslint-disable-next-line
          submitButton.value!.disabled = true;
      // Activate loading indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      // Send login request
      store
        .dispatch(Actions.VERIFY_OTP, {
          code: otp.value,
          email: resetForm.value.email,
        })
        .then((response) => {
          otpError.value = false;
          token.value = response.data.token;
          // store.commit(Mutations.SET_TOKEN, token.value);
          Swal.fire({
            text: response.message,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: translate("ok"),
            customClass: {
              confirmButton: "btn fw-bold btn-primary px-14",
            },
          }).then(() => {
            currentStepIndex.value = 3;
          });
        })
        .catch(() => {
          otpError.value = true;
          Swal.fire({
            text: store.getters.getErrors,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: translate("tryAgain"),
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        });

      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
          submitButton.value!.disabled = false;
    };

    const setNewPassword = () => {
      if (!newPasswordRef.value) return;

      newPasswordRef.value.validate((valid) => {
        if (valid) {
          store.commit(Mutations.SET_TOKEN, token.value);
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          // Activate loading indicator
          submitButton.value?.setAttribute("data-kt-indicator", "on");
          store
            .dispatch(Actions.SET_NEW_PASSWORD, {
              password: newPasswordForm.value.password,
            })
            .then((response) => {
              Swal.fire({
                text: response.message,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: translate("ok"),
                customClass: {
                  confirmButton: "btn fw-bold btn-primary px-14",
                },
              }).then(() => {
                // currentStepIndex.value = 3;
                router.push({ name: "sign-in" });
              });
            })
            .catch(() => {
              Swal.fire({
                text: store.getters.getErrors,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: translate("tryAgain"),
                customClass: {
                  confirmButton: "btn fw-bold btn-light-danger",
                },
              });
            });
          submitButton.value?.removeAttribute("data-kt-indicator");
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        }
      });
    };

    return {
      newPasswordRef,
      newPasswordForm,
      setNewPassword,
      onSubmitForgotPassword,
      resetFormRef,
      resetForm,
      submitButton,
      currentStepIndex,
      handleOnComplete,
      handleOnChange,
      otpInput,
      sendCodeAgain,
      otpError,
      verifiyOtp,
      token,
    };
  },
});
